import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import { useSite } from "@/context/SiteContext";

export default function Home() {
  const { loading } = useSite();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="font-heading uppercase tracking-widest text-sm text-neutral-500">
          Loading…
        </div>
      </div>
    );
  }
  return (
    <div className="bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Gallery />
      <About />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
}
